import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getTranslation, Button } from '@resy/ui-kitchen';
import StarIcon from '../../../images/rating-star-off-outline.svg';

const FiveStars = ({
  disabled, answerQuestion, questionId, questionsetId, options,
}) => {
  const [rating, setRating] = useState();
  const stars = options.slice(0, 5).map((opt, idx) => ({
    name: getTranslation({
      translationKey: `rate_${idx + 1}_star${idx === 0 ? '' : 's'}`,
      fallback: `${opt.text} Star${opt.text === '1' ? '' : 's'}`,
    }),
    rating: idx + 1,
    display: opt.text,
    id: opt.id,
  }));
  return (
    <div className="ratingStars" data-test-id="five-star">
      {stars.map((star) => (
        <Button
          className={cx('Button', 'RatingForm__star', {
            active: (rating && rating >= star.rating),
          })}
          disabled={disabled}
          variant="no-style"
          onClick={() => {
            if (!disabled) {
              answerQuestion(questionsetId, questionId, star.id, null);
              setRating(star.rating);
            }
          }}
          key={`${questionsetId}-${questionId}-${star.id}`}
        >
          <StarIcon
            width={40}
            height={40}
          />
          <span>{star.name}</span>
        </Button>
      ))}

    </div>
  );
};
FiveStars.propTypes = {
  questionsetId: PropTypes.number,
  answerQuestion: () => {},
  questionId: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      value: PropTypes.number,
      order: PropTypes.number,
    })
  ),
  disabled: PropTypes.bool,
};
FiveStars.defaultProps = {
  questionId: null,
  questionsetId: null,
  answerQuestion: () => {},
  options: [],
  disabled: false,
};

export default FiveStars;
